import apiClient from './client';

// Login and refresh answer 204 and set the HttpOnly cookies; there's no body.
export const login = (payload) => apiClient.post('/auth/login', payload).then(() => undefined);

// {email, password, first_name, last_name, training, job_title?, phone_number?}
export const register = (payload) => apiClient.post('/auth/register', payload).then(() => undefined);

// Uses the refresh cookie, so it works even after the access cookie has expired
export const logout = () => apiClient.post('/auth/logout').then(() => undefined);
